import { whatsappLink, MATRUM_APP_URL } from "../config";
import MatrumWord from "./MatrumWord";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden pt-36 pb-20 md:pt-44 md:pb-28"
    >
      {/* ambient color shapes */}
      <div className="pointer-events-none absolute -top-24 -right-24 h-96 w-96 rounded-full bg-rosa/40 blur-3xl" />
      <div className="pointer-events-none absolute top-1/2 -left-32 h-80 w-80 rounded-full bg-ambar/50 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
        <div className="lg:col-span-7 animate-fade-up">
          <h1 className="font-serif font-light text-[44px] leading-[1.05] sm:text-6xl lg:text-7xl text-ciruela tracking-tight">
            Acompañándote en
            <span className="block italic text-terracota">cada etapa</span>
            de tu vida
          </h1>
          <p className="font-body text-lg md:text-xl text-ciruela-dark/80 mt-8 max-w-xl leading-relaxed">
            Soy <strong className="font-semibold">Lorena Cotano</strong>, matrona y sexóloga. Acompaño a
            mujeres y parejas en momentos que lo transforman todo: embarazo, puerperio y menopausia.
            Trabajo con rigor científico, mirada íntegra y presencia humana, porque sé que no solo importa
            lo que te pasa, sino cómo lo vives.
          </p>

          <div className="flex flex-wrap items-center gap-4 mt-10">
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="font-sans font-medium rounded-full bg-terracota text-crema px-8 py-4 hover:bg-terracota-dark transition-colors duration-300"
            >
              Reserva tu sesión
            </a>
            <a
              href={MATRUM_APP_URL}
              data-testid="hero-cta-matrum"
              className="font-sans font-medium rounded-full border border-ciruela text-ciruela px-8 py-4 hover:bg-ciruela hover:text-crema transition-colors duration-300 inline-flex items-center gap-1.5"
            >
              Descubre <MatrumWord className="text-2xl" />
            </a>
          </div>
        </div>

        {/* Personal photo */}
        <div className="lg:col-span-5">
          <div
            data-testid="hero-photo"
            className="relative aspect-[4/5] rounded-[40px] overflow-hidden border border-rosa/50 shadow-xl"
          >
            <img
              src="/brand/lorena2.png"
              alt="Lorena Cotano, matrona y sexóloga"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ciruela-dark/15 to-transparent" />
            <span className="absolute top-5 left-5 h-10 w-10 border-t-2 border-l-2 border-crema/60 rounded-tl-2xl" />
            <span className="absolute bottom-5 right-5 h-10 w-10 border-b-2 border-r-2 border-crema/60 rounded-br-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
}
